import { StyledButton } from '@acg/frontend-ui-artpool';

export default StyledButton;
